module.exports = __webpack_public_path__ + "static/media/bronze_medal_icon.7378d411.svg";